const SPANISH_DAYS = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const SHORT_DAYS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];

/**
 * Get the Rosca season year. The season spans late December through January 6.
 * If today is in December, use next year; otherwise use current year.
 */
function getRoscaYear() {
    const now = new Date();
    const month = now.getMonth(); // 0-indexed
    // If we're in December, the upcoming Rosca season is next year's January
    if (month === 11) {
        return now.getFullYear() + 1;
    }
    return now.getFullYear();
}

/**
 * Build the three pickup dates (Jan 4, 5, 6) for the current Rosca season.
 */
function buildPickupDates(year) {
    return [4, 5, 6].map(day => {
        const date = new Date(year, 0, day); // Month 0 = January
        const dayOfWeek = SPANISH_DAYS[date.getDay()];
        const shortDay = SHORT_DAYS[date.getDay()];
        const dateStr = `${year}-01-${String(day).padStart(2, '0')}`;
        const displayStr = `${dayOfWeek} ${day} Enero`;
        return { dateStr, displayStr, shortLabel: `${shortDay} ${day}`, day };
    });
}

const ROSCA_YEAR = getRoscaYear();
const PICKUP_DATES = buildPickupDates(ROSCA_YEAR);

// Build mappings from the dynamic dates
const DATE_MAPPING = {};
const REVERSE_DATE_MAPPING = {};
PICKUP_DATES.forEach(({ dateStr, displayStr }) => {
    DATE_MAPPING[displayStr] = dateStr;
    REVERSE_DATE_MAPPING[dateStr] = displayStr;
});

/**
 * Converts display string (e.g., "Martes 6 Enero") to date format (e.g., "2026-01-06")
 * @param {string} displayString - The display string like "Martes 6 Enero"
 * @returns {string} Date in YYYY-MM-DD format
 */
export function displayStringToDate(displayString) {
    return DATE_MAPPING[displayString] || displayString;
}

/**
 * Converts date format (e.g., "2026-01-06") to display string (e.g., "Martes 6 Enero")
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {string} Display string like "Martes 6 Enero"
 */
export function dateToDisplayString(date) {
    return REVERSE_DATE_MAPPING[date] || date;
}

/**
 * Returns short label for display (e.g., "Mar 6" for "2026-01-06")
 * @param {string} date - Date in YYYY-MM-DD format
 * @returns {string} Short label like "Mar 6"
 */
export function getDisplayLabel(date) {
    const entry = PICKUP_DATES.find(p => p.dateStr === date);
    return entry ? entry.shortLabel : date;
}

/**
 * Get all date format values (YYYY-MM-DD strings for the 3 pickup days)
 * @returns {string[]} Array of dates in YYYY-MM-DD format
 */
export function getDateFormats() {
    return PICKUP_DATES.map(p => p.dateStr);
}

/**
 * Get the current Rosca season year
 * @returns {number}
 */
export function getRoscaSeasonYear() {
    return ROSCA_YEAR;
}

/**
 * Date options for day selector buttons in forms.
 * Each entry has { value: displayString, label: shortLabel }
 */
export const DATE_OPTIONS = PICKUP_DATES.map(({ displayStr, shortLabel }) => ({
    value: displayStr,
    label: shortLabel
}));

/**
 * Time slots available per pickup date.
 * Jan 4 has slightly fewer hours; Jan 5 and 6 stay open later.
 */
export const TIME_CONFIG = (() => {
    const config = {};
    PICKUP_DATES.forEach(({ dateStr, day }) => {
        const base = ['9am', '10am', '11am', '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm'];
        // Jan 5 and 6 have an extra 8pm slot
        if (day >= 5) {
            base.push('8pm');
        }
        config[dateStr] = base;
    });
    return config;
})();
